export const paginateTable = ({selector, dataSource, totalNumber, pageNumber, callMeBack}) => {
  var hasPaginationInitialized = false;
  $('#' + (selector || 'qubit-pagination-container')).pagination({
    dataSource,
    totalNumber,
    pageNumber,
    pageSize: 20,
    showGoInput: true,
    showGoButton: true,
    className: 'paginationjs-theme-grey paginationjs-small',
    afterInit: () => {
      hasPaginationInitialized = true;
    },
    callback: (data, pagination) => {
      if(hasPaginationInitialized === true) {
        hasPaginationInitialized = false;
        callMeBack(pagination.pageNumber);
      }
    }
  });
}